import { environment } from '../../../environments/environment';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders,
         HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { of } from 'rxjs/observable/of';
import { catchError, last, map, tap } from 'rxjs/operators';
import * as moment from 'moment';
import {InjectionService} from '../../service/injection.service';
declare var document;
@Component({
  selector: 'app-import-realise',
  templateUrl: './injection.component.html',
  styleUrls: ['./injection.component.css']
})
export class InjectionComponent implements OnInit {
   selected = 0;
   responseImport = [];
   progressBar = false;
   start: any;
   end: any;
  loading = false;

  text = 'Fichier';
  param = 'file';
  accept = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() complete = new EventEmitter<string>();

  files: Array<FileUploadModel> = [];
  inProgress = false;
  resultOpenFiche: any;
  importFileResult: any;
  collaborator: any;

  constructor(private _http: HttpClient, private injectionService: InjectionService) { }
  ngOnInit() {
      this.collaborator = JSON.parse(localStorage.getItem(environment.oauth.remoteUser))
  }
  downloadExampleFile() {
      this.injectionService.downloadFile('Matricule;Journée(DD/MM/YYYY);Début vac 1(HH:mm);Fin vac 1(HH:mm);Début vac 2(HH:mm);Fin vac 2(HH:mm);Début vac 3(HH:mm);Fin vac 3(HH:mm);Début vac 4(HH:mm);Fin vac 4(HH:mm);Pause (mm);Timezone \n', 'realise');
  }
  onClick() {
        const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
        fileUpload.onchange = () => {
              for (let index = 0; index < fileUpload.files.length; index++) {
                    const file = fileUpload.files[index];
                    this.files = [{ data: file, state: 'in',
                      inProgress: false, progress: 0, canRetry: false, canCancel: true }];
              }
              this.uploadFiles();
        };
        fileUpload.click();
  }

  cancelFile(file: FileUploadModel) {
        file.sub.unsubscribe();
        this.removeFileFromArray(file);
  }

  private uploadFile(file: FileUploadModel) {
      this.loading = true;
      this.progressBar = true;
        const fd = new FormData();
        const injecteur = this.collaborator.userName + '_' + new Date().getTime();
        console.log('uploadFile', this.collaborator.userName, injecteur);
        fd.append(this.param, file.data);
        fd.append('injecteur', injecteur);
        fd.append('demandeur', this.collaborator.userName);
        fd.set('matricule', this.collaborator.userName);
        let headers = {};
        const access_token = localStorage.getItem('access_token');
        if ( access_token !== null) {
              const token1 = access_token.substring(0, access_token.length / 2);
              const token2 = access_token.substring(access_token.length / 2, access_token.length);
              headers = {
                    'Intelcia1'     : token1,
                    'Intelcia2'     : token2
                  };
            }
        const req = new HttpRequest('POST', environment.api.myshiftUrl + '/tma/injectionCsvManager', fd, {
              reportProgress: true,
              headers: new HttpHeaders(headers)
        });

        file.inProgress = true;
        file.sub = this._http.request(req).pipe(
              map(event => {
                    switch (event.type) {
                          case HttpEventType.UploadProgress:
                                file.progress = Math.round(event.loaded * 100 / event.total);
                                break;
                          case HttpEventType.Response:
                                return event;
                    }
              }),
              tap(message => { }),
              last(),
              catchError((error: HttpErrorResponse) => {
                    file.inProgress = false;
                    file.canRetry = true;
                    return of(`${file.data.name} upload failed.`);
              })
        ).subscribe(
              async (event: any) => {
                    this.progressBar = true;
                    if (typeof (event) === 'object') {
                          this.responseImport = event.body;
                          this.removeFileFromArray(file);
                          this.complete.emit(event.body);
                          this.importFileResult = event.body;
                          this.start = new Date().setDate(new Date().getDate()-30);
                          this.start = moment(this.start).format('YYYY-MM-DD');
                          this.end = moment(new Date()).format('YYYY-MM-DD');

                          this.resultOpenFiche = await this.injectionService.realise(this.start,
                                this.end, injecteur,
                                'injectionRealise', () => {
                                      this.progressBar = false;
                                });
                          this.progressBar = false;
                          this.loading = false;
                    }
              }
        );
  }

  private uploadFiles() {
        const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
        fileUpload.value = '';

        this.files.forEach(file => {
              this.uploadFile(file);
        });
  }

  private removeFileFromArray(file: FileUploadModel) {
        const index = this.files.indexOf(file);
        if (index > -1) {
              this.files.splice(index, 1);
        }
  }

}
export class FileUploadModel {
  data: File;
  state: string;
  inProgress: boolean;
  progress: number;
  canRetry: boolean;
  canCancel: boolean;
  sub?: Subscription;
}



// WEBPACK FOOTER //
// ./src/app/view/injection/injection.component.ts